import {LocalDeviceDetectorService} from 'dmmp-services'
import {Component, EventEmitter, Input, Output} from '@angular/core'

@Component({
  selector: 'dmmp-floating-menu',
  templateUrl: './floating-menu.component.html'
})
export class FloatingMenuComponent {

  @Input() module
  @Input() identifier
  @Input() defaultClass = 'floating-menu'
  isCollapse = true
  medias = [
    {style: 'large', media: '(min-width:421px)'},
  ]
  @Output() filterEmitter = new EventEmitter()

  constructor(public localDeviceDetectorService: LocalDeviceDetectorService) {
  }

  filter(selectedTerm) {
    this.filterEmitter.emit(selectedTerm)
    this.module?.vocabularies[0]?.vocabulary?.terms?.forEach(termItem => {
      if (selectedTerm !== termItem) {
        termItem.active = false
      }
    })
  }
}
